// stores/navsplitter.ts
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useSplitterStore = defineStore(
  'navsplitter',
  () => {
    const panelSizeLeftInPixels = ref(200);
    const isCollapsed = ref(false);
    const collapsedWidth = 55; // 55px when collapsed

    function setPanelSizeLeftInPixels(sizeInPixels: number) {
      panelSizeLeftInPixels.value = sizeInPixels;
    }

    function toggleCollapse() {
      isCollapsed.value = !isCollapsed.value;
    }

    function setCollapsed(value: boolean) {
      isCollapsed.value = value;
    }

    return {
      panelSizeLeftInPixels,
      isCollapsed,
      collapsedWidth,
      setPanelSizeLeftInPixels,
      toggleCollapse,
      setCollapsed,
    };
  },
  {
    persist: true,
  },
);
